export enum ButtonVariant {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
  CANCEL = 'CANCEL',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TRANSPARENT = 'TRANSPARENT',
  TETRIERY = 'TETRIERY',
}
